/* ==========================================================================
   dewy — science-accordion.js
   Collapses the HOCl facts to titles on narrow screens; leaves them open on
   desktop.

   Why JS at all, when the FAQ accordion needs none: the FAQ is *always* an
   accordion, so it can just be a closed <details>. These facts are open on
   desktop and closed on mobile, and CSS cannot force a closed <details> open —
   the browser only renders non-summary children when the `open` attribute is
   present. So the attribute has to be toggled, and only script can do that.

   The markup ships with `open` on every panel. If this file fails to load, all
   four facts simply read as they always did — nothing is hidden behind a
   control that isn't working.
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE = '(max-width: 700px)';

  function apply(mq) {
    document.querySelectorAll('.sci-facts details').forEach(function (panel) {
      panel.open = !mq.matches;
    });
  }

  /* One MediaQueryList and one listener for the life of the page.

     The first version created a new one on every init, and init runs again on
     every shopify:section:load — so editing any section in the theme editor
     left another live listener behind, and after a few edits one breakpoint
     cross ran apply() a dozen times. Nothing here needs re-binding: apply()
     re-queries the DOM each run, so a replaced section is picked up by the
     listener that already exists. */
  var bound = false;

  function init() {
    if (!document.querySelector('.sci-facts details')) return;
    if (!window.matchMedia) return; // leave everything open

    var mq = window.matchMedia(MOBILE);
    apply(mq);

    if (bound) return;
    bound = true;

    // Only re-sync when the breakpoint is actually crossed, so a panel the
    // visitor opened isn't slammed shut by an address-bar resize.
    var onChange = function () { apply(mq); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange); // older Safari
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
